import Vue from 'vue'
import router from '@/router' //路由
import store from '@/store'; //Vuex
Vue.prototype.$store = store;


Vue.prototype.baseURL = process.env.NODE_BASE_URL
router.beforeEach((to, from, next) => {
  //获取买家对应货币符号
  store.dispatch("getUserForSymbol", to.name)

  if (to.name == 'Login') {
    if (from.name != "Register" && from.name != "Forgot") {
      window.localStorage.setItem('toLink', "/#" + from.path)
    } else {
      window.localStorage.setItem('toLink', "/")
    }
  }
  const nextPage = () => {
    // store.dispatch("userLog");
    // chrome
    document.body.scrollTop = 0
    // firefox
    document.documentElement.scrollTop = 0
    // safari
    // window.pageYOffset = 0//ie11 有问题

    /* 路由发生变化修改页面title */
    if (to.meta.title) {
      document.title = to.meta.title
    }
    next()
  }

  const toName = () => {
    if (to.name == 'home') {
      store.dispatch("getCookiesCategory")
      store.dispatch("checkUser").then(res => {})
      // _isMobile()
    }
    if (to.name == 'search') {
      store.dispatch("setSaveTime")
    }
    if (to.name == 'Account Settings') {
      store.dispatch("checkUser").then(res => {})
    }
  }

    //检查有没有活动的token
  const isActivityToken=()=>{
    if (store.state.activityToken) {
      nextPage()
    } else {
      store.dispatch('getActivityToken').then(res => {
        nextPage()
      })
    }
  }
  //var token = VueCookie.get('CardHobbyStoreToken') || '';
    //console.log(token,store.state.storeToken,123)
  // 检查有没有官方商城的token
  if (store.state.storeToken) {
    toName()
    isActivityToken()
    // if (store.state.activityToken) {
    //   nextPage()
    // } else {
    //   store.dispatch('getActivityToken').then(res => {
    //     nextPage()
    //   })
    // }
  } else {
   // console.log('false')
    store.dispatch('getStoreToken').then(res => {
      toName()
      if (res.Result == 1) {
        isActivityToken()
        //检查有没有活动的token
        // if (store.state.activityToken) {
        //   nextPage()
        // } else {
        //   store.dispatch('getActivityToken').then(res => {
        //     nextPage()
        //   })
        // }
      }
    })
  }
  //console.log(to, from, 'to, from')

  // 检查有没有活动的token
  //store.dispatch('isActivityToken')

  //store.dispatch('getCookiesActivity')

  // toName()
  // nextPage()
})


// WEBPACK FOOTER //
// ./src/utils/route_guards.js